import BaseRequest from './BaseRequest';

export default class CustomerFields extends BaseRequest {
    /**
     * CustomerFields constructor
     *
     * @param {string} requestMode
     * @param {string} providerId
     * @param {string} customerId
     * @param {boolean} auth
     * @param {boolean} fowardRequest
     */
    constructor(
        requestMode = 'customer',
        providerId = '',
        customerId = '',
        auth = true,
        fowardRequest = false,
    ) {
        super(requestMode, providerId, customerId, auth, fowardRequest);
        this.setClassName('CustomerFields');
        this.setEndpoint('customer_fields');
    }

    /**
     * @return {object}
     */
    async getRegistrationFields() {
        return await this.getCustomerRegistrationFields();
    }

    /**
     * Return fields TeamUp shows on the new customer form.
     *
     * @return {object}
     */
    async getNewCustomerFormFields() {
        const listResponse = await this.listAll(100);

        return {
            ...listResponse,
            results: (listResponse?.results ?? []).filter(
                (field) => field.show_on_new_customer_form === true,
            ),
        };
    }

    /**
     * Return fields TeamUp applies to customer registration.
     *
     * TeamUp includes optional fields here too; use the returned field's
     * requiredness properties such as is_required to decide if it is mandatory.
     *
     * @return {object}
     */
    async getCustomerRegistrationFields() {
        const listReponse = await this.listAll(20, [], [], '', {
            applicable_scenario: 'customer_registration',
        });

        return listReponse;
    }

    /**
     * @return {object}
     */
    async getRequiredRegistrationFields() {
        return await this.getCustomerRegistrationFields();
    }
}
